import { useHookstate } from '@hookstate/core';
import { Button } from 'primereact/button';
import React, { useEffect } from 'react';
import { agreeTemplate, currentCoffret, scrollToTop, statutCoffretTemplate } from '../ScrbTools';
import { I18n } from 'aws-amplify';
import ControleCoffret from './ControleCoffret';

const Coffret = () => {
    const selectedCoffret = useHookstate(currentCoffret);

    useEffect(() => {
        scrollToTop();
        // eslint-disable-next-line
    }, []);

    return (
        <div className="card">
            <div className="flex align-items-center">
                <div className="flex-1"><h5>{selectedCoffret.get().code}</h5></div>
                <div className="flex-1">{statutCoffretTemplate(selectedCoffret.get().status)}</div>
            </div>
            <hr />
            <div className='flex flex-column'>
                <h2 className='text-xl font-semibold mb-4'>
                    <i className="fa-light fa-gauge mr-2"></i>
                    {I18n.get("donneesCoffret")}
                </h2>
                <div className='cdm-form-label'>{I18n.get("cMarque")}</div>
                <div className='cdm-form-data'>{selectedCoffret.get().cMarque || ''}</div>
                <div className='cdm-form-label'>{I18n.get("pMarque")}</div>
                <div className='cdm-form-data'>{selectedCoffret.get().pMarque || ''}</div>
                <div className='cdm-form-label'>{I18n.get("modele")}</div>
                <div className='cdm-form-data'>{selectedCoffret.get().modele || ''}</div>
                <div className='cdm-form-label'>{I18n.get("numeroSerie")}</div>
                <div className='cdm-form-data'>{selectedCoffret.get().numeroSerie || ''}</div>
                <div className='cdm-form-label'>{I18n.get("aggreation")}</div>
                <div className='flex justify-content-start'>
                    <span>{agreeTemplate(selectedCoffret.get().agreeMazout, selectedCoffret.get().status, "Mazout")}</span>
                    <span className='pl-2'>{agreeTemplate(selectedCoffret.get().agreeGaz, selectedCoffret.get().status, "Gaz")}</span>
                </div>
                <div className='pt-4 '>
                    <hr />
                    {(selectedCoffret.get().lastControl && <ControleCoffret controle={JSON.parse(selectedCoffret.get().lastControl)} />)
                        || <div>{I18n.get("pasDeControle")}</div>}
                </div>
            </div>
            <div className="flex justify-content-start">
                <Button
                    label={I18n.get("back")}
                    icon="pi pi-arrow-left"
                    className='p-button-outlined'
                    onClick={() => selectedCoffret.set({})}
                />
            </div>
        </div>
    )
}

export default Coffret;
